import axios from "axios";

export const UserService = () => {
    const changeDetail = async (data) => {
        return await axios.post(
            `${process.env.REACT_APP_API_URL}v1/logged/user/change-detail`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            }
        );
    };

    const changePassword = async (data) => {
        return await axios.post(
            `${process.env.REACT_APP_API_URL}v1/logged/user/change-password`,
            data,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            }
        );
    };

    return { changeDetail, changePassword };
};
